import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import './InfoItem.scss'
import { StackInfoItem } from '@components/Home/InfoItem/InfoItem.style'
const InfoItem = ({ title, description, img, isWithImg, isService }) => {
  console.log('🚀 ~ InfoItem ~ isWithImg:', isWithImg)
  const { t } = useTranslation()
  const isInlineSvg = typeof img !== 'string'

  return (
    <StackInfoItem
      isWithImg={isWithImg}
      className='text-icon'
      isService={isService}
    >
      <Stack>
        {isInlineSvg ? (
          img
        ) : (
          <img
            src={img}
            alt={t(`${title}`)}
            style={{ width: '32px', height: '32px' }}
          />
        )}
      </Stack>
      <Stack>
        <Typography sx={{ fontWeight: 700 }}>{t(`${title}`)}</Typography>
        <Typography>{t(`${description}`)}</Typography>
      </Stack>
    </StackInfoItem>
  )
}

export default InfoItem
